import aiNativeBehaviorEvaluator from './aiNativeBehaviorEvaluator';

/**
 * Web-native llmBehavior: evaluates source.query via sourceEvaluator, then calls
 * AI LLM generate directly. Same contract as server llmBehavior.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const query = sourceEvaluator ? await sourceEvaluator(source.query) : source.query;
  const response = await aiNativeBehaviorEvaluator.llmGenerate(query);
  return response;
};
export default {
  evaluate
};